import { LocationMarkerIcon, OfficeBuildingIcon } from "@heroicons/react/solid";
import planeUpIcon from "../../assets/plane-up-solid.svg";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlaneUp } from "@fortawesome/free-solid-svg-icons";

function AutoCompletePlaceItem({ placeTerms, onClick, isSelected }) {
  return (
    <div
      onClick={onClick}
      // className={` bg-[#eae9e9] flex space-x-3 px-2 py-1 rounded-sm items-center  hover:bg-secondary hover:text-white cursor-pointer`}
      className={`bg-[#eae9e9] flex space-x-3 px-2 py-1 rounded-sm items-center hover:bg-secondary hover:text-white cursor-pointer ${
        isSelected ? "bg-secondary text-white" : "" // Apply selected styles
      }`}
    >
      {/* change in icons based on location type (only hotels, airport, and drivado) */}
      {placeTerms && placeTerms[0]?.value?.includes("Drivado") ? (
        <div className="text-3xl font-['Helvetica'] font-bold text-primary">
          d
        </div>
      ) : placeTerms[0].value.includes("Airport") ? (
        <FontAwesomeIcon icon={faPlaneUp} className="w-4 text-gray-400" />
      ) : placeTerms[0].value.includes("Hotel") ? (
        <OfficeBuildingIcon className="w-4 text-gray-400" />
      ) : (
        <LocationMarkerIcon className="w-4 text-gray-400" />
      )}
      <div>
        <div className="text-sm  font-thin">{placeTerms[0]?.value}</div>
        <div className="text-sm">
          {placeTerms[1]?.value} {placeTerms[2]?.value} {placeTerms[3]?.value}
        </div>
      </div>
      <div></div>
    </div>
  );
}

export default AutoCompletePlaceItem;

export const AutoCompletePlaceItemFlatRegion = ({ placeTerms, onClick }) => {
  return (
    <div
      onClick={onClick}
      className="bg-[#eae9e9] flex space-x-3 px-2 py-1 rounded-sm items-center  hover:bg-secondary hover:text-white cursor-pointer"
    >
      {/* change in icons based on location type (only hotels, airport, and drivado) */}
      {placeTerms?.name?.includes("Drivado") ? (
        <div className="text-3xl font-['Helvetica'] font-bold text-primary">
          d
        </div>
      ) : placeTerms?.name?.includes("Airport") ? (
        <FontAwesomeIcon icon={faPlaneUp} className="w-4 text-gray-400" />
      ) : placeTerms?.name?.includes("Hotel") ? (
        <OfficeBuildingIcon className="w-4 text-gray-400" />
      ) : (
        <LocationMarkerIcon className="w-4 text-gray-400" />
      )}
      <div>
        <div className="text-sm  font-thin">
          {`${
            placeTerms.category === "airport"
              ? `${placeTerms?.name} ${
                  placeTerms?.iata ? `(${placeTerms?.iata})` : ""
                }`
              : placeTerms.name
          }`}
        </div>
        <div className="text-sm">
          {placeTerms?.address &&
            placeTerms?.address?.addressOne &&
            placeTerms?.address?.addressOne}
          {placeTerms?.cityName && placeTerms?.cityName},
          {placeTerms.category === "airport" ? placeTerms?.country : ""}
        </div>
      </div>
      <div></div>
    </div>
  );
};
